/** Reset scroll lock / pointer capture Privy leaves on html + body after modal close. */
export const unlockPrivyDocument = () => {
  const html = document.documentElement
  const body = document.body

  for (const el of [html, body]) {
    el.style.removeProperty('position')
    el.style.removeProperty('top')
    el.style.removeProperty('left')
    el.style.removeProperty('right')
    el.style.removeProperty('width')
    el.style.removeProperty('height')
    el.style.removeProperty('overflow')
    el.style.removeProperty('pointer-events')
    el.style.removeProperty('touch-action')
    el.classList.remove('privy-modal-open')
  }
}

const elementLooksVisible = (el: HTMLElement): boolean => {
  const style = window.getComputedStyle(el)
  if (style.display === 'none' || style.visibility === 'hidden') return false
  if (Number(style.opacity) < 0.05) return false
  if (el.getAttribute('aria-hidden') === 'true') return false
  const rect = el.getBoundingClientRect()
  return rect.height > 40 && rect.width > 40
}

export const privyModalLooksOpen = (): boolean => {
  for (const id of ['privy-modal-content', 'privy-dialog']) {
    const el = document.getElementById(id)
    if (el && elementLooksVisible(el as HTMLElement)) return true
  }
  return false
}

/**
 * After wallet connect on mobile, Privy often leaves `#privy-dialog` /
 * `#privy-dialog-backdrop` mounted at z-index 999999 (sometimes aria-hidden but
 * still display:block + pointer-events:auto). That paints as a black screen over
 * an otherwise healthy React tree.
 *
 * Only runs once the user is authenticated (`mem-wallet-ready`) so we never
 * tear down the live connect/login modal.
 */
export const stripStalePrivyShell = (): boolean => {
  if (!document.body.classList.contains('mem-wallet-ready')) return false
  if (privyModalLooksOpen()) return false

  const ids = ['privy-dialog-backdrop', 'privy-modal-content', 'privy-dialog']
  let removed = false
  for (const id of ids) {
    const el = document.getElementById(id)
    if (!el) continue
    try {
      el.remove()
      removed = true
    } catch {
      /* ignore */
    }
  }

  return removed
}

/** Run after a successful wallet session — not during login/connect. */
export const cleanupPrivyShell = () => {
  unlockPrivyDocument()
  document.body.classList.add('mem-wallet-ready')
  stripStalePrivyShell()
}
